var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 26,
    viewBox: "0 0 19 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.7997H11V11.0874H15V12.7997Z",
    fill: "#0E8ECE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53039 10.266L8.46973 9.05523L6.00006 11.8744L5.03039 10.7675L3.96973 11.9782L6.00006 14.2959L9.53039 10.266Z",
    fill: "#0E8ECE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19.6487H11V17.9365H15V19.6487Z",
    fill: "#0E8ECE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 19.9341H7.5V17.6511H5.5V19.9341Z",
    fill: "#0E8ECE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 0.813843C5.30109 0.813843 5.11032 0.904042 4.96967 1.0646C4.82902 1.22515 4.75 1.44291 4.75 1.66997V2.52611H1C0.585786 2.52611 0.25 2.90941 0.25 3.38224V24.5002C0.25 24.973 0.585786 25.3563 1 25.3563L18 25.3563C18.1989 25.3563 18.3897 25.2661 18.5303 25.1055C18.671 24.945 18.75 24.7272 18.75 24.5002V3.38224C18.75 2.90941 18.4142 2.52611 18 2.52611H14.25V1.66997C14.25 1.19715 13.9142 0.813843 13.5 0.813843H5.5ZM14.25 4.23837V5.0945C14.25 5.56733 13.9142 5.95063 13.5 5.95063H5.5C5.08579 5.95063 4.75 5.56733 4.75 5.0945V4.23837H1.75V23.644L17.25 23.644V4.23837H14.25ZM12.75 4.23837H6.25V2.52611H12.75V4.23837Z",
    fill: "#0E8ECE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElements);
export default __webpack_public_path__ + "static/media/elements.e715df3737b39266d42ffc6ed120fd3d.svg";
export { ForwardRef as ReactComponent };